/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';

export default {
    saveVendorPolicy(payload) {
        return HttpService.put(environment.API_VENDOR_PRIVACY_POLICY, payload);
    },
    searchVendorPolicy(dataTypeId) {
        return HttpService.get(
            environment.API_VENDOR_PRIVACY_POLICY +
                `?dataSubjectTypeIds=${dataTypeId}`
        );
    },
    getVendorPolicyDetail(policyId) {
        return HttpService.get(
            environment.API_VENDOR_PRIVACY_POLICY + `/${policyId}`
        );
    },
    getVendorPolicyDetailPublic(policyId) {
        return HttpServiceNoToken.get(
            environment.API_VENDOR_PRIVACY_POLICY_PUBLIC +
                `/publish-version/${policyId}`
        );
    },
    //History
    getHistories(params) {
        return HttpService.get(
            environment.API_VENDOR_PRIVACY_POLICY + `/history`,
            {
                params,
            }
        );
    },
    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_VENDOR_PRIVACY_POLICY + `/history/detail`,
            {
                params,
            }
        );
    },
    deleteVendorPolicy(policyId) {
        return HttpService.delete(
            environment.API_VENDOR_PRIVACY_POLICY + `/${policyId}`
        );
    },
    rename(payload) {
        return HttpService.put(
            environment.API_VENDOR_PRIVACY_POLICY + '/rename',
            payload
        );
    },
    getPublishedVersion(id) {
        return HttpService.get(
            environment.API_VENDOR_PRIVACY_POLICY + `/publish-version/` + id
        );
    },
};
